import React, { createContext, useContext } from 'react';
import {
  useWizardState,
  WizardStateInterface,
} from '../../hooks/useWizardState';

export type InterventionWizardInterface = WizardStateInterface;

export const InterventionWizardContext = createContext<
  InterventionWizardInterface | undefined
>(undefined);

export const useInterventionWizardContext = () => {
  const context = useContext(InterventionWizardContext);
  if (context === undefined) {
    throw new Error(
      'useInterventionWizardContext must be used within a InterventionWizardProvider'
    );
  }
  return context;
};

type Props = {
  children: React.ReactNode;
};

export const InterventionWizardProvider = ({ children }: Props) => {
  const wizardState = useWizardState();

  return (
    <InterventionWizardContext.Provider value={wizardState}>
      {children}
    </InterventionWizardContext.Provider>
  );
};
